import { useState, useCallback } from "react";
import { getBoundary } from "../services/external.service";

export const useField = (initialValue, baseFields) => {
    const [value, setValue] = useState(initialValue);

    const callBackStates = useCallback((accessToken, mapKey) => {
        function getStatesByContryCode(accessToken, mapKey) {
            const auxMap = value instanceof Map ? new Map(value) : new Map();
            const mapEntry = auxMap.has(mapKey) ? auxMap.get(mapKey) : null;
            if (mapEntry && mapEntry.country && mapEntry.country.value) {
                getBoundary(accessToken, mapEntry.country.value).then(response => {
                    if (Array.isArray(response) && response.length > 0) {
                        response.sort((a, b) => {
                            let fa = a.name.toLowerCase(),
                                fb = b.name.toLowerCase();
                            if (fa < fb) {
                                return -1;
                            }
                            if (fa > fb) {
                                return 1;
                            }
                            return 0;
                        });
                        auxMap.set(mapKey, {
                            ...mapEntry,
                            states: [...response]
                        });
                        setValue(auxMap);
                    }
                    else {
                        auxMap.set(mapKey, {
                            ...mapEntry,
                            states: []
                        });
                        setValue(auxMap);
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        }
        getStatesByContryCode(accessToken, mapKey)
    }, [value])

    const handleChange = (event, mapKey, fieldName, actionMeta) => {
        const { type } = event;
        const currentFields = value instanceof Map && value.has(mapKey) ? value.get(mapKey) : baseFields
        switch (type) {
            case 'click':
                value.set(mapKey,{
                    ...currentFields,
                    [fieldName] :  actionMeta.props
                })
                break;

            case 'change':
                value.set(mapKey,{
                    ...currentFields,
                    [event.target.name] :  event.target.value
                })
                break;

            case 'keydown':
                value.set(mapKey,{
                    ...currentFields,
                    [fieldName] :  actionMeta.props
                })
                break;

            default:
                value.set(mapKey, {
                    ...currentFields,
                    [fieldName]: [...event]
                })
                break
        }

        setValue(new Map(value))
    };

    const reset = useCallback((mapKey) => {
        const auxMap = value instanceof Map ? new Map(value) : new Map();
        auxMap.set(mapKey, { ...baseFields })
        setValue(auxMap)
    }, [baseFields, value]);


    return {
        value,
        onChange: handleChange,
        reset,
        callBackStates
    };
}